/* Related to the `dropzone` CSS block. */

export class Case {
    constructor() {
        const dropzone = $(".dropzone");

        dropzone.on("dragover", function () {
            $(this).addClass("dropzone--hover");
        });

        dropzone.on("dragleave", function () {
            $(this).removeClass("dropzone--hover");
        });

        $(".dropzone-file").on("change", function (e) {
            const element = this as HTMLInputElement;
            const file = element.files![0];
            $(e.target).siblings(".dropzone-title").html(file.name);
        });
    }
}
